import { QueryClient } from '@tanstack/react-query';

/**
 * Shared QueryClient.
 *
 * Defaults are tuned for an interactive PWA:
 * - `staleTime` of 60s keeps cached data warm enough that brief tab switches
 *   don't trigger jarring refetch flashes. Individual queries can still override.
 * - `retry: 1` gives transient network errors one chance to recover without
 *   masking real failures behind long retry storms.
 * - `refetchOnWindowFocus: false` avoids the surprise "data jumps" feel when a
 *   user alt-tabs back. Background refetches still happen via `refetchInterval`
 *   or explicit invalidations.
 */
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 60_000,
			retry: 1,
			refetchOnWindowFocus: false,
		},
	},
});
